export enum eChartsVerticalAlign {
    top = 'top',
    middle = 'middle', // Seems like the best choice much of the time.
    bottom = 'bottom'
}
